export default __webpack_public_path__ + "static/media/f1.3853c94b.svg";